import RangeSelector from "devextreme-react/range-selector";
import includes from "lodash/includes";
import styled, { css } from "styled-components";
import { PRESENTATION_TEXT_FILTER_DEF_ID, TIMELINE_RANGE_SELECTOR_MODE } from "../constants";
export default {
    RangeSelector: styled(RangeSelector).withConfig({
        shouldForwardProp: (prop) => !includes(["mode", "canChangeInterval", "inPlayProgress", "presentationState"], prop)
    }) `
    ${({ canChangeInterval, mode }) => !canChangeInterval
        ? css `
            .dxrs-trackers > .slider-tracker,
            .dxrs-slidersContainer > .slider,
            .selected-area-tracker {
              pointer-events: none;
            }
          `
        : mode === TIMELINE_RANGE_SELECTOR_MODE.PRESENTATION &&
            css `
            .dxrs-trackers > path + .slider-tracker,
            .dxrs-slidersContainer > path + .slider,
            .selected-area-tracker {
              pointer-events: none;
            }
          `}

    ${({ presentationState }) => presentationState === "pause" || presentationState === "play"
        ? css `
            .dxrs-series-group .dxc-series > g {
              fill: #c2b5f9 !important;
            }
          `
        : css `
            .dxrs-series-group .dxc-series > g {
              fill: #dfe5ec !important;
            }
          `}
    ${({ mode }) => mode === TIMELINE_RANGE_SELECTOR_MODE.PRESENTATION
        ? css `
            .dxrs-slidersContainer > path + .slider > path {
              stroke-width: 4px !important;
              stroke: #6745f1 !important;
            }

            .dxrs-range-selector-elements > text {
              filter: url(#${PRESENTATION_TEXT_FILTER_DEF_ID});
            }
          `
        : css `
            .dxrs-series-group .dxc-labels rect {
              filter: url(#${PRESENTATION_TEXT_FILTER_DEF_ID});
              height: 12px;
              y: -12px !important;
            }
          `}

    .dxrs-slidersContainer > .slider > path {
      stroke-linecap: round;
    }

    .dxc-markers > rect[width="1"] {
      width: 0.75em;
    }
  `
};
